import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import InstallPWA from "@/components/InstallPWA";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import VenueDetail from "@/pages/VenueDetail";
import Coupons from "@/pages/Coupons";
import CouponDetail from "@/pages/CouponDetail";
import MyCoupons from "@/pages/MyCoupons";
import RoutesPage from "@/pages/Routes";
import RouteBuilder from "@/pages/RouteBuilder";
import RouteDetail from "@/pages/RouteDetail";
import Community from "@/pages/Community";
import BeerEducation from "@/pages/BeerEducation";
import About from "@/pages/About";
import ForBusinesses from "@/pages/ForBusinesses";
import ForBrands from "@/pages/ForBrands";
import Redeem from "@/pages/Redeem";
import CityLanding from "@/pages/CityLanding";
import ComingSoon from "@/pages/ComingSoon";
import { FEATURE_FLAGS } from "@/lib/featureFlags";

import { AdminAuthProvider } from "@/lib/adminAuth";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminVenues from "@/pages/admin/AdminVenues";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPins from "@/pages/admin/AdminPins";

function PublicChrome({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <InstallPWA />
    </>
  );
}

function AppRoutes() {
  return (
    <Routes>
      {/* Página standalone del BAR (sin Navbar/Footer público) */}
      <Route path="/canjear" element={<Redeem />} />

      {/* Admin (layout propio) */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="venues" element={<AdminVenues />} />
        <Route path="coupons" element={<AdminCoupons />} />
        <Route path="reviews" element={<AdminReviews />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="pins" element={<AdminPins />} />
      </Route>

      {/* Público (con Navbar/Footer) */}
      <Route path="/*" element={
        <PublicChrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/descubrir" element={<Discover />} />
            <Route path="/local/:id" element={<VenueDetail />} />
            <Route path="/cupones" element={<Coupons />} />
            <Route path="/cupones/:id" element={<CouponDetail />} />
            <Route path="/mis-cupones" element={<MyCoupons />} />
            {/* Alias del nuevo branding "Huesos" */}
            <Route path="/huesos" element={<Coupons />} />
            <Route path="/huesos/:id" element={<CouponDetail />} />
            <Route path="/mis-huesos" element={<MyCoupons />} />
            <Route path="/rutas" element={<RoutesPage />} />
            <Route path="/rutas/nueva" element={<RouteBuilder />} />
            <Route path="/rutas/:id" element={<RouteDetail />} />
            <Route path="/comunidad" element={<Community />} />
            <Route path="/cervezas" element={<BeerEducation />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/about" element={<About />} />
            <Route path="/locales" element={<ForBusinesses />} />
            <Route
              path="/marcas"
              element={FEATURE_FLAGS.brandsPublic ? <ForBrands /> : <ComingSoon />}
            />
            <Route path="/ciudad/:slug" element={<CityLanding />} />
          </Routes>
        </PublicChrome>
      } />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <AdminAuthProvider>
            <AppRoutes />
          </AdminAuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
